import { testimonials } from "@/mocks/testimonials";

export default function VoicesSection() {
  return (
    <ul className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
      {testimonials.map((item) => (
        <li key={item.user}>
          <figure className="h-full flex flex-col p-5 rounded-lg bg-background-50 border border-background-200/80">
            <span className="w-8 h-8 rounded-md bg-primary-100 text-primary-700 flex items-center justify-center text-base">
              <i className="ri-chat-quote-line"></i>
            </span>
            <blockquote className="mt-4 text-sm text-foreground-700 leading-relaxed flex-1">{item.content}</blockquote>
            <figcaption className="mt-5 pt-4 border-t border-background-200 flex items-center gap-3">
              <span className="w-9 h-9 rounded-full bg-secondary-500 text-background-50 flex items-center justify-center text-sm">
                {item.user.slice(0, 1)}
              </span>
              <span className="min-w-0">
                <span className="block text-sm text-foreground-900">{item.user}</span>
                <span className="block text-xs text-foreground-400">{item.role}</span>
              </span>
              <span className="ml-auto flex items-center gap-1 text-xs text-foreground-400">
                <span className="w-3.5 h-3.5 flex items-center justify-center">
                  <i className="ri-heart-3-line"></i>
                </span>
                {item.likes}
              </span>
            </figcaption>
          </figure>
        </li>
      ))}
    </ul>
  );
}